"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPrimitive = exports.easeliveSportIds = exports.VideoStatus = void 0;
var zod_1 = require("zod");
var video_1 = require("../analytics/video");
// https://ballysports.atlassian.net/wiki/spaces/EN/pages/74809357/Video
var VideoStatus;
(function (VideoStatus) {
    VideoStatus["live"] = "live";
    VideoStatus["upcoming"] = "upcoming";
    VideoStatus["replay"] = "replay";
    VideoStatus["vod"] = "vod";
})(VideoStatus || (exports.VideoStatus = VideoStatus = {}));
exports.easeliveSportIds = zod_1.z.enum(['NHL', 'MLB', 'NBA']).optional();
var EaseliveZod = zod_1.z.object({
    sport_radar_game_id: zod_1.z.string().optional(),
    broadcast_team_id: zod_1.z.string().optional(),
    project_id: zod_1.z.string().optional(),
    sport_id: exports.easeliveSportIds,
    user_id: zod_1.z.string().optional(),
    showFdOdds: zod_1.z.boolean().optional()
});
exports.VideoPrimitive = zod_1.z.object({
    /** The id of the video */
    id: zod_1.z.string().describe('video id'),
    /** The title of the video */
    title: zod_1.z.string().describe('video title'),
    /** video status */
    status: zod_1.z.nativeEnum(VideoStatus).describe('video status'),
    /** An optional video description */
    description: zod_1.z.string().optional().describe('video description'),
    /** An image thumbnail URL */
    thumbnail: zod_1.z.string().describe('thumbnail'),
    requires_couch_rights: zod_1.z
        .boolean()
        .describe('boolean indicating whether of not the video requires couch rights'),
    hero_thumbnail: zod_1.z.string().optional().describe('thumbnail'),
    /** video start */
    start_date: zod_1.z.date().optional().describe('video start'),
    /** video end */
    end_date: zod_1.z.date().optional().describe('video end'),
    /** video stream type: "vod" | "linear" */
    stream_type: zod_1.z.nativeEnum(video_1.StreamType).describe('video stream type'),
    /** ease live object */
    easelive: EaseliveZod.optional(),
    /** optional broadcast channel, should only be populated for live airings */
    channel: zod_1.z.string().optional().describe('optional broadcast channel'),
    redeemable_amount: zod_1.z.number()
});
